import { Controller, useForm } from "react-hook-form"
import Input from "../../../components/form-controls/Input";
import InvalidFeedback from "../../../components/InvalidFeedback";
import Tags from "../../../components/Tags";
import Select from "../../../components/form-controls/Select";
import Button from "../../../components/form-controls/Button";
import { TicketsAssignmentsService } from "../../../services/TicketsAssignmentsService";
import { useEffect, useMemo, useState } from "react";
import { AlertService } from "../../../services/Alert";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import { useTranslation } from "react-i18next";
import useRequest from "../../../hooks/useRequest";
import Loader from "../../../components/Loader";
import TextArea from "../../../components/form-controls/TextArea";
function TicketsAssignmentsPartial() {

    const { t } = useTranslation();

    const { account } = useCurrentAccount();
    const {call, isRequesting} = useRequest();
    const [quantity, setQuantity] = useState<any>();
    const [timeUnit, setTimeUnit] = useState();
    const [timeOptions, setTimeOptions] = useState([]);
    const defaultValues = {
        account_id: 0,
        max_tickets: 1,
        automatic_assignment: 0,

        labels_tickets: [],

        time_live_ticket: 0,
        time_live_ticket_unit: '',

        default_category: '',
        message_timeout: ''
    }

    const { control, register, handleSubmit, reset, formState: { errors, isValid, isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const submit = async(data) => {
        try {
            data.automatic_assignment =  data.automatic_assignment ? 1: 0
            data.labels_tickets = data.labels_tickets.join(',')
            data.time_live_ticket = Number(data.time_live_ticket);
            await TicketsAssignmentsService.update(data);

            AlertService.success('¡Éxito!', 'Se guardó la configuración correctamente');
        } catch (error) {
            console.error(error);
            AlertService.error('¡Error!', 'Ocurrió un error al guardar la configuración, intenta nuevamente')
        }
    }

    const getConfig = async() => {
        const { data } = await call(() => TicketsAssignmentsService.getConfig(account.id));
        reset({
            account_id: data.account_id,
            max_tickets: data.max_tickets,
            automatic_assignment: data.automatic_assignment,
            labels_tickets: data.labels_tickets ? data.labels_tickets.split(','): [],
            time_live_ticket: data.time_live_ticket,
            time_live_ticket_unit: data.time_live_ticket_unit,
            default_category: data.default_category,
            message_timeout: data.message_timeout
        })
        setQuantity(data.time_live_ticket);
        setTimeUnit(data.time_live_ticket_unit);
    }

    useEffect(() => {
        getConfig()
    }, [])
    useEffect(() => {
        if (timeUnit === 'minutes') {
            setTimeOptions(Array.from({ length: 11 }, (_, i) => ({ value: (i + 1) * 5, text: `${(i + 1) * 5}` })));
        } else if (timeUnit === 'hours') {
            setTimeOptions(Array.from({ length: 168 }, (_, i) => ({ value: i + 1, text: `${i + 1}` })));
        } else {
            setTimeOptions([]);
        }
    }, [timeUnit]);
    const heightRequesting = useMemo(()=> {return isRequesting ? 'h-200':''},[isRequesting]);
    return (
        <>
            <div className="card">

                <div className="card-header d-flex align-items-center">
                    <div className="me-3">
                        <h2 className="card-title h4">{t("config.tickets-assignment.tickets-title")}</h2>
                        {/* <p className="small mb-0">
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis distinctio ipsum ad sapiente aperiam perspiciatis reiciendis ducimus sint, similique non repellat beatae temporibus error omnis repellendus voluptas! Soluta, incidunt tempora!
                        </p> */}
                    </div>

                </div>

                <div className={`card-body relative ${heightRequesting}`}>
                    {
                        isRequesting ? <Loader/> :
                            <>
                                <div className="row">
                                    <div className="col-5">
                                        <h5>{t("config.tickets-assignment.config-title")}</h5>
                                        <p>{t("config.tickets-assignment.config-p")}</p>
                                    </div>
                                    <div className="col-7">
                                        <div className="mb-3">
                                            <Input label= {t("config.tickets-assignment.limit-label")} errors={errors.max_tickets} {...register('max_tickets', )} />
                                        </div>
                                        <div className="form-check mb-3">
                                            <input type="checkbox" className="form-check-input" id={`automatic_assignment`} {...register(`automatic_assignment`)} />
                                            <label className="form-check-label" htmlFor={`automatic_assignment`} >{t("config.tickets-assignment.config-checkbox")}</label>
                                        </div>
                                    </div>
                                </div>
                                <hr />

                                <div className="row">
                                    <div className="col-5">
                                        <h5>{t("config.tickets-assignment.monitoring-title")}</h5>
                                        <p>{t("config.tickets-assignment.monitoring-p")}</p>
                                    </div>
                                    <div className="col-7">
                                        <div className="mb-3">
                                            <label className="form-label" >{t("config.tickets-assignment.monitoring-label")}</label>
                                            <Controller
                                                control={control}
                                                name={'labels_tickets'}
                                                render={({
                                                    field: { onChange, value },
                                                    fieldState: { error },
                                                }) => {
                                                    return (
                                                        <Tags
                                                            isInvalid={error ? true : false}
                                                            onChange={(values: any) => onChange(values)}
                                                            initialValue={Array.isArray(value) ? value.map(v => ({ value: v, label: v })) : []}
                                                        />
                                                    )
                                                }}
                                            />
                                            <InvalidFeedback error={errors?.labels_tickets} />
                                        </div>
                                    </div>
                                </div>
                                <hr />

                                <div className="row">
                                    <div className="col-5">
                                        <h5>{t("config.tickets-assignment.config-inactivity-title")}</h5>
                                        <p>{t("config.tickets-assignment.config-inactivity-p")}</p>
                                    </div>
                                    <div className="col-7">

                                        <div className="row mb-3">
                                            <div className="col">
                                                <Select
                                                    label={t("config.tickets-assignment.time-activity")}
                                                    data={timeOptions}
                                                    {...register('time_live_ticket', {
                                                        onChange: (e) => setQuantity(e.target.value)
                                                    })}
                                                    value={quantity}
                                                />
                                            </div>
                                            <div className="col">
                                                <Select
                                                    label={t("config.tickets-assignment.time-unit")}
                                                    data={[
                                                        {
                                                            value: '',
                                                            text: t("config.tickets-assignment.select"),
                                                            disabled: true,
                                                        },
                                                        {
                                                            value: 'minutes',
                                                            text: t("config.tickets-assignment.minutes")
                                                        },
                                                        {
                                                            value: 'hours',
                                                            text: t("config.tickets-assignment.hours")
                                                        },
                                                    ]}
                                                    errors={errors.time_live_ticket_unit}
                                                    {...register(`time_live_ticket_unit`, {
                                                        onChange: (e) => setTimeUnit(e.target.value)
                                                    })}
                                                />
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <Input label={t("config.tickets-assignment.closure-label")} errors={errors.default_category} {...register('default_category',)} />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">{t("config.tickets-assignment.message-timeout-title")}</label>
                                            <p className="m-0">{t("config.tickets-assignment.message-timeout-description")}</p>
                                            <TextArea
                                                {...register('message_timeout',)}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-end">
                                    <Button type="submit" className="btn btn-primary btn-sm" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>{t("btn-save")}</Button>
                                </div>

                            </>
                    }
                </div>
            </div>
        </>
    )

}
export default TicketsAssignmentsPartial